import React from 'react';
import Layout from '../components/Layout';

import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';




import LiteratureServices from '../components/literatureservices';
import ManuscriptHeader from '../components/manuscriptheader';
import LiteratureHeader from '../components/literatureheader';
import useScrollTransition from '../useScrollTransition';


const LiteraturePage = () => {
  useScrollTransition();
  return (
    <Layout>
      
        <LiteratureHeader/>
        <ScrollingText/>
        <LiteratureServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default LiteraturePage;